(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product_vibe-popup"] && !Shopify.designMode) return;
  try {
    (function () {
      if (window.vibePopupBound) return;
      window.vibePopupBound = true;

      document.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-vibe-popup-open]');
        if (opener) {
          var dialog = document.getElementById('VibePopup-' + opener.getAttribute('data-vibe-popup-open'));
          if (dialog && typeof dialog.showModal === 'function') {
            // Escape any transformed ancestor (the theme's scroll animations use
            // transforms, which would otherwise trap this top-layer dialog and pin it
            // to the top of that ancestor instead of centering it in the viewport).
            if (dialog.parentNode !== document.body) document.body.appendChild(dialog);
            dialog.showModal();
          }
          return;
        }

        var closer = event.target.closest('[data-vibe-popup-close]');
        if (closer) {
          var owner = closer.closest('dialog');
          if (owner) owner.close();
          return;
        }

        // A click that lands on the dialog element itself is the letterbox around the
        // content — treat it as a click outside and close.
        if (event.target.classList && event.target.classList.contains('vibe-popup__dialog')) {
          event.target.close();
        }
      });
    })();
  } catch(e) { console.error(e); }
})();

})();
